import React from "react";

export const CompassRose = ({ size = 80, className = "" }) => {
  return (
    <div
      className={`compass-rose ${className}`}
      aria-hidden="true"
      style={{
        position: "absolute",
        top: 24,
        left: 24,
        width: `${size}px`,
        height: `${size}px`,
        zIndex: 3,
        pointerEvents: "none",
        opacity: 0.85,
        filter: "drop-shadow(0px 2px 6px rgba(0,0,0,0.3))",
      }}
    >
      <svg
        viewBox="0 0 100 100"
        width="100%"
        height="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="50" cy="50" r="46" stroke="#8B1E0F" strokeWidth="1.5" strokeDasharray="2 3" />
        <circle cx="50" cy="50" r="42" stroke="#8B1E0F" strokeWidth="1" />
        {/* North pointer */}
        <polygon points="50,10 54,46 50,50" fill="#8B1E0F" />
        <polygon points="50,10 46,46 50,50" fill="#D97706" />
        {/* South pointer */}
        <polygon points="50,90 54,54 50,50" fill="#78350F" />
        <polygon points="50,90 46,54 50,50" fill="#B45309" />
        {/* East pointer */}
        <polygon points="90,50 54,54 50,50" fill="#8B1E0F" />
        <polygon points="90,50 54,46 50,50" fill="#D97706" />
        {/* West pointer */}
        <polygon points="10,50 46,54 50,50" fill="#78350F" />
        <polygon points="10,50 46,46 50,50" fill="#B45309" />
        {/* Cardinal Letter N */}
        <text
          x="50"
          y="7"
          textAnchor="middle"
          fill="#8B1E0F"
          fontSize="9"
          fontWeight="bold"
          fontFamily="serif"
        >
          N
        </text>
        <circle cx="50" cy="50" r="3" fill="#D97706" />
      </svg>
    </div>
  );
};
